// extracted by mini-css-extract-plugin
module.exports = {"button":"ForgotPassword_button__3ncYz","social":"ForgotPassword_social__3PBiP","form":"ForgotPassword_form__1jtBD","title":"ForgotPassword_title__3PvZX"};